document.querySelectorAll('.typography iframe[width][height]').forEach(iframe => {
    const w = parseFloat(iframe.getAttribute('width'));
    const h = parseFloat(iframe.getAttribute('height'));

    if (w > 0 && h > 0) {
    iframe.style.aspectRatio = `${w} / ${h}`;
}
});
